import { render, staticRenderFns } from "./Ayuda.vue?vue&type=template&id=6c3e30d9&scoped=true"
import script from "./Ayuda.vue?vue&type=script&lang=js"
export * from "./Ayuda.vue?vue&type=script&lang=js"
import style0 from "./Ayuda.vue?vue&type=style&index=0&id=6c3e30d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e30d9",
  null
  
)

export default component.exports